import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Moon = createReactComponent("Moon", ["svg", defaultAttributes, [["path", {
  d: "M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z",
  key: "1qo1pg"
}]]]);
export default Moon;